"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- SORTABLELIST : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'SortableList',
  group: _definitionhelpers.groupNames.lists,
  props: {
    name: {
      type: 'string'
    },
    klass: {
      type: 'string'
    },
    items: {
      type: 'object',
      default: [{
        value: 'PAYPAL',
        text: 'Paypal'
      }, {
        value: 'CHECKS',
        text: 'Check (US Only)'
      }, {
        value: 'ACH',
        text: 'Direct Deposit / ACH (US only)'
      }, {
        value: 'WIRE',
        text: 'Wire Transfer (international payment method)'
      }]
    },
    selected: {
      type: 'object'
    },
    disabled: {
      type: 'object'
    },
    error: {
      type: 'object',
      default: {
        enabled: false,
        message: 'This is an error!'
      }
    },
    order: {
      type: 'object',
      default: ['PAYPAL', 'ACH', 'WIRE', 'CHECKS']
    },
    handleChange: {
      type: 'function',
      default: function _default() {
        return console.log("Change");
      },
      disabled: true,
      help: {
        title: _definitionhelpers.helpMessages.functions["title"],
        desc: _definitionhelpers.helpMessages.functions["desc"] + " This component must provide a handleChange function as a prop which handles selections/deselections of drag item checkboxes",
        link: {}
      }
    },
    handleOrderChange: {
      type: 'function',
      default: function _default() {
        return console.log("Order Changed");
      },
      disabled: true,
      help: {
        title: _definitionhelpers.helpMessages.functions["title"],
        desc: _definitionhelpers.helpMessages.functions["desc"] + " For dragEnd events, the parent function handleOrderChange will be called with the new item list (order changed).",
        link: {}
      }
    }
  }
};
exports.default = _default2;